<template>
  <div class="wrap">
    <div class="success-img">
      <img src="../assets/403.png" alt="" />
    </div>
  </div>
</template>
<script setup lang="ts">
</script>
<style scoped lang="less">
.wrap {
  // background: #eff2f5;
  height: 100%;
  .success-img {
    width: 4.26rem;
    height: 3.32rem;
    margin: 0.62rem auto;
    img {
      width: 100%;
    }
  }
}
</style>
